import Grid from '@material-ui/core/Grid';
import MaskDestination from 'components/modules/service/PayerDetail/Transactions/config/MaskDestination';
import PropTypes from 'prop-types';
import { ReadOnlyFormControl } from 'components/common/fields';
import { decryptDestination, decryptFunding } from 'sdk/transactionHistory';
import { memo } from 'react';
import usePayALoanPayerOffOn from 'hooks/usePayALoanPayerOffOn';
import {
  TRANSACTION_TYPE_PAL,
  TRANSACTION_TYPE_PAL_PRINCIPAL,
  TRANSACTION_TYPE_PAL_INTEREST,
  TRANSACTION_TYPE_PAL_ESCROW,
} from 'consts';
import AutoPayOrFrequency from './AutoPayOrFrequency';
import CardInfo from './CardInfo';
import DeliveryType from './DeliveryType';
import IPayMerchantId from './iPayMerchantId';
import DisburseState from './DisburseState';
import MaskFunding from '../../../config/MaskFunding';
import RDFIInfo from './RDFIInfo';
import Type from '../../Type';
import useLoad from './useLoad';
import { isP2P } from './consts';
import FraudScore from './FraudScore';
import FeeAmount from './PalAmounts/FeeAmount';
import Amount from './PalAmounts/Amount';
import TotalAmount from './PalAmounts/TotalAmount';
import AppliedTo from './PalAmounts/AppliedTo';
import usePayALoanTransaction from './usePayALoanTransaction';
import ValidateInstantPayment from './validateInstantPayment';
import OntracUserId from './OntracUserId';

const DetailsRender = ({ transaction }) => {
  const palEnabled = usePayALoanPayerOffOn(
    transaction.fspId,
    transaction.payerId
  );

  useLoad(transaction);

  const isPalType =
    transaction.transactionType === TRANSACTION_TYPE_PAL ||
    transaction.transactionType === TRANSACTION_TYPE_PAL_PRINCIPAL ||
    transaction.transactionType === TRANSACTION_TYPE_PAL_INTEREST ||
    transaction.transactionType === TRANSACTION_TYPE_PAL_ESCROW;

  return (
    <Grid container>
      <Grid item xs={1}>
        <Type item={transaction} />
      </Grid>
      <Grid item xs={1}>
        <ReadOnlyFormControl
          label="Send Date"
          value={transaction.sendOnDerived}
        />
      </Grid>
      <Grid item xs={4}>
        <ReadOnlyFormControl
          inputNode={
            !isPalType && transaction.fundingMask ? (
              <MaskFunding decrypt={decryptFunding} icon item={transaction} />
            ) : null
          }
          label="Funding Account"
          value={
            isPalType
              ? transaction.fundingAccount || transaction.fundingMask || ''
              : transaction.fundingMask || ''
          }
        />
      </Grid>
      <Grid item xs={2}>
        <ReadOnlyFormControl
          label="Status"
          multiline
          value={transaction.statusDerived}
        />
      </Grid>
      <Grid item xs={2}>
        <ReadOnlyFormControl
          label="Deliver Date"
          value={transaction.deliverOnDerived}
        />
      </Grid>
      <Grid item xs={2}>
        <ReadOnlyFormControl
          label="Confirmation #"
          value={transaction.confirmationNumber}
        />
      </Grid>
      <Grid item xs={1}>
        <AutoPayOrFrequency transaction={transaction} />
      </Grid>
      <Grid item xs={1}>
        <ReadOnlyFormControl label="History ID" value={transaction.id} />
      </Grid>
      <Grid item xs={4}>
        <ReadOnlyFormControl
          inputNode={
            !(
              transaction.transactionType === TRANSACTION_TYPE_PAL ||
              transaction.transactionType === TRANSACTION_TYPE_PAL_PRINCIPAL ||
              transaction.transactionType === TRANSACTION_TYPE_PAL_INTEREST ||
              transaction.transactionType === TRANSACTION_TYPE_PAL_ESCROW ||
              isP2P(transaction.transactionType)
            ) && (
              <MaskDestination
                decrypt={decryptDestination}
                icon
                item={transaction}
              />
            )
          }
          label="Destination Account"
          value={
            transaction.transactionType === TRANSACTION_TYPE_PAL ||
            transaction.transactionType === TRANSACTION_TYPE_PAL_PRINCIPAL ||
            transaction.transactionType === TRANSACTION_TYPE_PAL_INTEREST ||
            transaction.transactionType === TRANSACTION_TYPE_PAL_ESCROW
              ? transaction.destination
              : transaction.destination
              ? transaction.destination
              : transaction.destinationMask
          }
        />
      </Grid>
      <Grid item xs={2}>
        <ReadOnlyFormControl
          label="Funding Response"
          value={transaction.fundingResponse}
        />
      </Grid>
      <DisburseState transaction={transaction} />
      {!usePayALoanTransaction(transaction.transactionType) && (
        <Grid item xs={2}>
          <ReadOnlyFormControl
            label="Delivery Method"
            value={transaction.deliveryMethodValue}
          />
        </Grid>
      )}
      <FraudScore transaction={transaction} />
      {ValidateInstantPayment(transaction.disburseTypeDerived) && (
        <DeliveryType transaction={transaction} />
      )}
      <RDFIInfo transaction={transaction} />
      <CardInfo transaction={transaction} />
      {!usePayALoanTransaction(transaction.transactionType) && (
        <Grid item xs={3}>
          <ReadOnlyFormControl
            label={transaction.trackingLabelDerived}
            value={transaction.trackingNumberDerived}
          />
        </Grid>
      )}
      {ValidateInstantPayment(transaction.disburseTypeDerived) && (
        <>
          <Grid item xs={3}>
            <ReadOnlyFormControl
              label="PayCenter ID"
              value={transaction.payCenterId}
            />
          </Grid>
          <Grid item xs={3}>
            <ReadOnlyFormControl
              label="PayCenter Request ID"
              value={transaction.payCenterRequestId}
            />
          </Grid>
        </>
      )}
      <IPayMerchantId transaction={transaction} />
      {palEnabled && <AppliedTo transaction={transaction} />}
      {palEnabled && <Amount transaction={transaction} />}
      {palEnabled && <FeeAmount transaction={transaction} />}
      {palEnabled && <TotalAmount transaction={transaction} />}
      <OntracUserId transaction={transaction} />
    </Grid>
  );
};

DetailsRender.propTypes = {
  transaction: PropTypes.object.isRequired,
};

export default memo(DetailsRender);
